export default __webpack_public_path__ + "static/media/open_in_new_black_24dp.d3558aa5.svg";